import { ENV } from '../config/env';

const getBasePath = () => {
  return ENV.isProduction ? ENV.api.prod : ENV.api.dev;
};

export const API_ENDPOINTS = {
  register: `${getBasePath()}/register`,
  setCustomerPayment: `${getBasePath()}/setCustomerPayment`,
  cancelStripeSubscription: `${getBasePath()}/cancelStripeSubscription`,
  verifyCaptcha: `${getBasePath()}/verifyCaptcha`,
  checkEmailAvailable: `${getBasePath()}/checkEmailAvailable`,
  renewSubscription: `${getBasePath()}/renewSubscription`,
  emailSubscribe: `${getBasePath()}/emailSubscribe`,
  receiptValidation: `${getBasePath()}/receiptValidation`,
  verifyPromoCode: `${getBasePath()}/verifyPromoCode`,
  verifyCustomerPayment: `${getBasePath()}/verifyCustomerPayment`,
  getProductsList: `${getBasePath()}/getProductsList`,
  getCustomToken: `${getBasePath()}/getCustomToken`,
};
